"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var getStateName = function (action) {
    return action && action.type === '@@redux/INIT'
        ? 'initialState argument passed to createStore'
        : 'previous state received by the reducer';
};
var validateNextState = function (nextState, reducerName, action) {
    // eslint-disable-next-line no-undefined
    if (nextState === undefined) {
        throw new Error("Reducer \"" + reducerName + "\" returned undefined when handling \"" + action.type + "\" action. To ignore an action, you must explicitly return the previous state.");
    }
};
var getUnexpectedInvocationParameterMessage = function (state, reducers, action) {
    var reducerNames = Object.keys(reducers);
    if (!reducerNames.length) {
        return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
    }
    var stateName = getStateName(action);
    if (!immutable_1.isImmutable(state)) {
        return "The " + stateName + " is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: \"" + reducerNames.join('", "') + "\".";
    }
    var unexpectedStatePropertyNames = state
        .toSeq()
        .keySeq()
        .toList()
        .toArray()
        .filter(function (name) {
        return !reducers.hasOwnProperty(name);
    });
    if (unexpectedStatePropertyNames.length > 0) {
        return "Unexpected " + (unexpectedStatePropertyNames.length === 1
            ? 'property'
            : 'properties') + " \"" + unexpectedStatePropertyNames.join('", "') + "\" found in " + stateName + ". Expected to find one of the known reducer property names instead: \"" + reducerNames.join('", "') + "\". Unexpected properties will be ignored.";
    }
    return null;
};
function combineReducers(reducers, DefaultState) {
    var reducerKeys = Object.keys(reducers);
    return function (inputState, action) {
        if (inputState === void 0) { inputState = new DefaultState(); }
        if (process.env.NODE_ENV !== 'production') {
            var warningMessage = getUnexpectedInvocationParameterMessage(inputState, reducers, action);
            if (warningMessage) {
                console.error(warningMessage);
            }
        }
        return inputState.withMutations(function (temporaryState) {
            reducerKeys.forEach(function (reducerName) {
                var reducer = reducers[reducerName];
                if (!reducer) {
                    console.error("Make sure the key \"" + reducerName + "\" instance of reducers. Reducer keys: " + reducerKeys.join(', '));
                    return;
                }
                var currentDomainState = temporaryState.get(reducerName);
                var state = currentDomainState === null
                    ? undefined
                    : currentDomainState;
                var nextDomainState = reducer(state, action);
                validateNextState(nextDomainState, reducerName, action);
                temporaryState.set(reducerName, nextDomainState);
            });
        });
    };
}
exports.default = combineReducers;
//# sourceMappingURL=combineReducers.js.map